import { translate } from '@jsverse/transloco';
export enum Risk {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    CRITICAL = 'CRITICAL',
}

export class RiskHelper {
    static getLocaleFromRisk(risk: Risk): string {
        switch (risk) {
            case Risk.LOW:
                return translate('CORE.RISKS.LOW');
            case Risk.MEDIUM:
                return translate('CORE.RISKS.MEDIUM');
            case Risk.HIGH:
                return translate('CORE.RISKS.HIGH');
            case Risk.CRITICAL:
                return translate('CORE.RISKS.CRITICAL');
            default:
                return '';
        }
    }
}
